import {
  oneOfType, func, string, shape,
} from 'prop-types'

export const _component = oneOfType([
  func,
  string,
  shape({ render: func.isRequired }),
])
